import type { ComponentType } from 'react';
import { WelcomeTourSection } from './sections/WelcomeTourSection';
import { ShareCompanyCodeSection } from './sections/ShareCompanyCodeSection';
import { AddCandidateSection } from './sections/AddCandidateSection';
import { ScheduleInterviewSection } from './sections/ScheduleInterviewSection';
import { ScheduleAssessmentSection } from './sections/ScheduleAssessmentSection';
import { TrackSessionsSection } from './sections/TrackSessionsSection';
import { InviteTeamSection } from './sections/InviteTeamSection';
import { ReadBillingSection } from './sections/ReadBillingSection';
import { ShareCandidateGuideSection } from './sections/ShareCandidateGuideSection';

export interface GuideSectionEntry {
  id: string;
  label: string;
  subtitle: string;
  component: ComponentType;
  adminOnly?: boolean;
}

export const ADMIN_GUIDE_SECTIONS: GuideSectionEntry[] = [
  {
    id: 'welcome',
    label: 'Welcome & Portal Tour',
    subtitle: '60-second overview',
    component: WelcomeTourSection,
  },
  {
    id: 'share-company-code',
    label: 'Share Your Company Code',
    subtitle: 'Link candidates to your tenant',
    component: ShareCompanyCodeSection,
  },
  {
    id: 'add-candidate',
    label: 'Add Your First Candidate',
    subtitle: 'The Candidates roster',
    component: AddCandidateSection,
  },
  {
    id: 'schedule-interview',
    label: 'Schedule an Interview',
    subtitle: 'The 3-step wizard',
    component: ScheduleInterviewSection,
  },
  {
    id: 'schedule-assessment',
    label: 'Schedule an Assessment',
    subtitle: 'Tests and take-homes',
    component: ScheduleAssessmentSection,
  },
  {
    id: 'track-sessions',
    label: 'Track Sessions & Transcripts',
    subtitle: 'Status badges, transcript, coaching',
    component: TrackSessionsSection,
  },
  {
    id: 'invite-team',
    label: 'Invite Your Team',
    subtitle: 'Roles and magic-link invites',
    component: InviteTeamSection,
    adminOnly: true,
  },
  {
    id: 'billing',
    label: 'Read Your Billing',
    subtitle: 'Plan, pricing, trial, invoices',
    component: ReadBillingSection,
  },
  {
    id: 'candidate-guide',
    label: 'Share the Candidate Guide',
    subtitle: 'Public link for candidates',
    component: ShareCandidateGuideSection,
  },
];
